import * as yup from "yup";

export const CompanyAssetsSchema = yup.object().shape({
  name: yup.string().required("Required"),
  assetId: yup.string().required("Required"),
  photo: yup.mixed().required("Required"),
  price: yup.number().required("Required"),
  assignTo: yup.string(),
  assignDate: yup.string().when("assignTo", {
    is: (val) => val,
    then: (s) => s.required("Assign date is required"),
  }),
  status: yup.string(),
  description: yup.string(),
});

export const CompanyAssetsInfo = {
  name: "",
  assetId: "",
  photo: "",
  price: "",
  assignTo: "",
  assignDate: "",
  status: "",
  description: "",
};
